import ArrowRightSvg from '@/assets/ArrowRightSvg.svg';
import LoveRobotSvg from '@/assets/LoveRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogDesktop from '@/components/dialog/DialogDesktop.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import React from 'react';

export interface ThankfulMessageProps {
  buttonLabel: string;
  handleClick: (event: React.FormEvent) => void;
  message: string;
  title: string;
}

const ThankfulMessageDesktop: React.FC<ThankfulMessageProps> = ({
  buttonLabel,
  handleClick,
  message,
  title,
}) => {
  return (
    <div className="flex gap-20 mt-20 flex-1 justify-content-center w-full">
      <div className="relative flex flex-col justify-center items-center gap-20">
        <DialogDesktop
          arrow={
            <img
              alt="arrow-down"
              className="absolute -z-10 -right-10 bottom-1/4 transform -translate-y-1/2"
              src={ArrowRightSvg}
            />
          }
          content={message}
          message={title}
        />
        <ButtonWithLoading className="align-self-md-center" onClick={handleClick}>
          {buttonLabel}
        </ButtonWithLoading>
      </div>
      <div style={{ maxHeight: '60vh' }}>
        <img
          alt="love-robot"
          className="w-full h-100"
          src={generateNonCachableImageSrc(LoveRobotSvg)}
        />
      </div>
    </div>
  );
};

export default ThankfulMessageDesktop;
